<template>
  <SfButton
    class="a-add-to-cart sf-button--full-width"
    :disabled="isProductDisabled"
    @click.native="addToCart"
  >
    {{ label }}
  </SfButton>
</template>

<script>
import { SfButton } from '@storefront-ui/vue';
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages';
import { notifications } from '@vue-storefront/core/modules/cart/helpers';
import { mapGetters, mapActions } from 'vuex';
import StoreSelector from 'src/modules/vsf-inventory-sources/mixins/StoreSelector'

export default {
  name: 'AAddToCart',
  mixins: [ StoreSelector ],
  components: {
    SfButton
  },
  props: {
    product: {
      required: true,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    qty: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      default: 'online bestellen'
    },
    isPickupButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isAddingToCart: 'cart/getIsAdding',
    }),
    isProductDisabled () {
      return (
        this.disabled ||
        formatProductMessages(this.product.errors) !== '' ||
        this.isAddingToCart
      );
    }
  },
  methods: {
    ...mapActions({
      openMicrocart: 'ui/toggleMicrocart'
    }),
    async addToCart () {
      this.$store.dispatch(
        'inventorySources/setIsPickup',
        this.isPickupButton
      )

      try {
        const diffLog = await this.$store.dispatch('cart/addItem', {
          productToAdd: Object.assign({}, this.product, { qty: this.qty })
        });
        this.openMicrocart();
        diffLog.clientNotifications.forEach(notificationData => {
          this.$store.dispatch(
            'notification/spawnNotification',
            notificationData,
            { root: true }
          );
        });
      } catch (message) {
        this.$store.dispatch(
          'notification/spawnNotification',
          notifications.createNotification({ type: 'danger', message }),
          { root: true }
        );
      }
    }
  }
};
</script>
